import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=7af89a5b&scoped=true&"
import script from "./Tour.vue?vue&type=script&lang=js&"
export * from "./Tour.vue?vue&type=script&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&id=7af89a5b&scoped=true&lang=css&"
import style1 from "./Tour.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af89a5b",
  null
  
)

export default component.exports